export const locale = {
  lang: 'fr-CA',
  data: {
    DOCUMENTATION: {
      TITLE: 'Base de connaissance',
    },
  },
};
